//TODO:  this is a quick and dirty phone number pipe.   Need to handle other formats including non-us numbers

import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'epPhone',
    standalone: false
})
export class PhonePipe implements PipeTransform {
    transform(phone: any) {
        if (!phone) {
            return phone;
        }
        let phoneNumber: string = '';

        if (phone.Phone_Num && phone.Phone_Num != null) {
            phoneNumber = phone.Phone_Num;
        }

        var value = phoneNumber
            .toString()
            .trim()
            .replace(/^\+/, '');
        var formatted = value;

        switch (value.length) {
            case 7: // ###-####
                formatted = value.slice(0, 3) + '-' + value.slice(3, 6);
                break;

            case 10: // ###-###-####
                formatted = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6, 10);
                break;

            case 11: // #-###-###-####
                formatted = value.slice(0, 1) + '-' + value.slice(1, 4) + '-' + value.slice(4, 7) + '-' + value.slice(7, 11);
                break;

            default:
                formatted = value;
        }

        if (phone.Phone_Ext && phone.Phone_Ext.length > 0) {
            // phone 'object' passed in
            formatted = formatted.trim() + '  x' + phone.Phone_Ext;
        }

        return formatted.trim(); //+  " (raw=" + value + ")";
    }
}
